import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { homeFor, useAuth } from './AuthProvider';
import { FullLoader, Forbidden } from '@/components/States';

/** Рольові маршрути. Справжній захист — RLS на сервері; це лише UX-маршрутизація. */
export function RequireRole({ role, children }: { role: 'parent' | 'student' | 'admin' | 'editor' | 'teacher'; children: ReactNode }) {
  const { session, profile, isAdmin, isEditor, isTeacher, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <FullLoader />;
  if (!session) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}${role === 'student' ? '&mode=child' : ''}`} replace />;
  if (!profile) return <Forbidden text="Профіль не знайдено. Спробуйте вийти й увійти знову." />;
  if (profile.status !== 'active') return <Forbidden text="Доступ призупинено. Зверніться до батьків." />;
  if (role === 'admin') return isAdmin ? <>{children}</> : <Forbidden />;
  if (role === 'editor') return isEditor ? <>{children}</> : <Forbidden text="Кабінет викладача доступний викладачам і методистам. Роль видає адміністратор." />;
  if (role === 'teacher') return isTeacher || isAdmin ? <>{children}</> : <Forbidden />;
  if (profile.kind !== role) return <Navigate to={homeFor(profile)} replace />;
  return <>{children}</>;
}

/** Сторінки входу/реєстрації: якщо вже увійшли — на свою головну. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const { session, profile, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (session && profile) return <Navigate to={homeFor(profile)} replace />;
  return <>{children}</>;
}
